export var VELT_SDK_VERSION = '4.5.0-beta.59';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.5.0-beta.59': 'sha384-eWscGajF6BzcUBxoKHK7eISXUIe6nlmpsRIYa7F0GZz9jYMQGI5d4D7hgtfzgF4z',
};
